const imageMixin = {
  methods: {
    /**
     * 显示本地图片编辑器
     */
    onShowImageEditor() {
      this.dialogImageVisible = !0
    },
    /**
     * 删除图片前的钩子
     * @param file
     * @param fileList
     * @returns {Promise<boolean|undefined>}
     */
    async onBeforeRemoveImage(file) {
      await this.removeImage(file)
    },
    onRemoveImage(file) {
      for (const [index, item] of this.localImageList.entries()) {
        if (file.name === item.name) {
          this.localImageList.splice(index, 1)
          return
        }
      }
    },
    /**
     * 图片发生改变时的回调
     * @param file
     */
    onChangeImage(file) {
      if (!this.localImageList.some(image => image.name === file.name)) {
        this.localImageList.push(file)
				this.showUploadLoading = true
      }
    },
		onUploadImageSuccess(response, file, fileList) {
			const isAllUploaded = fileList.findIndex(image => image.status !== 'success') === -1
			if (isAllUploaded) {
				this.showUploadLoading = false
			}
		},
    /**
     * 保存上传的图片
     */
    onSaveImage() {
      for (let i = this.localImageList.length - 1; i >= 0; i--) {
				const file = this.localImageList[i]
				if (file.status === 'success') {
					const img = document.createElement('img')
					img.id = new Date().getTime().toString()
					img.style.display = 'block'
					img.style.width = 'calc(100% - 2em)'
					img.style.height = 'auto'
					img.src = this.localImageList[i].url
					img.alt = this.localImageList[i].name
					img.className = 'area__container'
					this.beforeInsertElement(img)
				}
      }
      this.dialogImageVisible = !1
    },
    /**
     * 上传本地图片
     * @param options
     * @returns {Promise<void>}
     */
    async onUploadImage(options) {
      const { file } = options
      const data = new FormData()
      data.append('QRCodeID', this.getQrcodeId())
      data.append('Files', file)
      const { success, data: result } = await this.$http({
        data,
        url: this.$api.savePic,
        method: 'post',
        isUploadOrDownload: true,
      })
      if (success) {
        for (const [key, value] of Object.entries(result)) {
          for (const [index, fileListItem] of this.localImageList.entries()) {
            if (key === fileListItem.name) {
              this.$set(this.localImageList, index, {
                ...fileListItem,
                url: `${WEB_CONFIG.BASE_URL}/${value}`,
              })
            }
          }
        }
      }
    },
    /**
     * 删除本地上传的图片
     * @param file
     * @returns {Promise<boolean>}
     */
    async removeImage(file) {
      const qrcodeID = this.getQrcodeId()
      const { success } = await this.$http({
        url: this.$api.deletePic,
        method: 'delete',
        params: {
          fileName: file.name,
          qrcodeID,
        },
      })
      return success
    },
  },
}
export default imageMixin
